import { ControllerFieldState, ControllerRenderProps, FieldValues, RegisterOptions } from 'react-hook-form';

import { WfSelectProps } from '../wf-select/index';
import { WfCascaderProps } from '../wf-cascader';
import { WfInputProps } from '../wf-input/index';
import { WfTextareaProps } from '../wf-textarea/index';
import { WfCheckboxProps, WfCheckboxGroupProps } from '../wf-checkbox';
import { WfDatePickerProps } from '../wf-date-picker';

export type RenderProps = {
  field: ControllerRenderProps<FieldValues, string>;
  fieldState: ControllerFieldState;
  rules?: RegisterOptions;
};

type SelectRenderProps = Pick<WfSelectProps, 'value' | 'variation' | 'onChange'>;

type CascaderRenderProps = Pick<WfCascaderProps, 'value' | 'variation' | 'onChange'>;

type InputRenderProps = Pick<WfInputProps, 'value' | 'variation' | 'onChange' | 'onBlur'>;

type TextareaRenderProps = Pick<WfTextareaProps, 'value' | 'variation' | 'onChange' | 'onBlur'>;

type DayPickerProps = Pick<WfDatePickerProps, 'value' | 'variation' | 'onChange' | 'onBlur'>;

type CheckboxRenderProps = Pick<WfCheckboxProps, 'checked' | 'onChange'>;

type CheckboxGroupRenderProps = Pick<WfCheckboxGroupProps, 'value' | 'onChange'>;

export function convertSelect(renderProps: RenderProps): SelectRenderProps {
  const { field, fieldState } = renderProps;

  return {
    value: field.value || '',
    variation: fieldState.error ? 'error' : undefined,
    onChange: field.onChange,
  };
}

export function convertCascader(renderProps: RenderProps): CascaderRenderProps {
  const { field, fieldState } = renderProps;

  return {
    value: field.value || [],
    variation: fieldState.error ? 'error' : undefined,
    onChange: field.onChange,
  };
}

export function convertInput(renderProps: RenderProps): InputRenderProps {
  const { field, fieldState } = renderProps;

  return {
    value: field.value || '',
    variation: fieldState.error ? 'error' : undefined,
    onChange: field.onChange,
    onBlur: field.onBlur,
  };
}

export function convertTextarea(renderProps: RenderProps): TextareaRenderProps {
  const { field, fieldState } = renderProps;

  return {
    value: field.value || '',
    variation: fieldState.error ? 'error' : undefined,
    onChange: field.onChange,
    onBlur: field.onBlur,
  };
}

export function convertCheckbox(renderProps: RenderProps): CheckboxRenderProps {
  const { field } = renderProps;

  return {
    checked: field.value,
    onChange: field.onChange,
  };
}

export function convertCheckboxGroup(renderProps: RenderProps): CheckboxGroupRenderProps {
  const { field } = renderProps;

  return {
    value: field.value || [],
    onChange: field.onChange,
  };
}

export function convertDayPicker(renderProps: RenderProps): DayPickerProps {
  const { field, fieldState } = renderProps;

  return {
    value: field.value || undefined,
    variation: fieldState.error ? 'error' : undefined,
    onChange: field.onChange,
    onBlur: field.onBlur,
  };
}
